import { createStyles, makeStyles } from "@material-ui/styles";
import * as React from "react";

import { RelodeTheme } from "../../";

export const useMessagingStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "stretch",
                flexGrow: 1,
            },
            listingRoot: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                flexBasis: "50%",
            },
            listingContainer: {
                marginTop: 5,
                marginLeft: 40,
            },
            pageSectionContent: {
                margin: theme.spacing(2),
                flexGrow: 1,
            },
            keywordInput: {
                margin: theme.spacing(1, 0, 2, 0),
            },
            searchButton: {
                padding: 0,
            },
            searchButtonIcon: {
                fontSize: "1rem",
            },
            toWrapper: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            },
            toText: {
                marginRight: theme.spacing(1),
            },
            details: {
                padding: `${theme.spacing(1)}px ${theme.spacing(
                    3
                )}px 0 ${theme.spacing(3)}px`,
                display: "flex",
                flexDirection: "column",
                flex: 1,
            },
            detailsTo: {
                color: theme.relode.colors.backgroundText.main,
                marginRight: theme.spacing(1),
            },
            contextName: {
                color: theme.relode.colors.pageSecondaryColor,
            },
            columnsWrapper: {
                display: "flex",
                flexDirection: "row",
                flexGrow: 1,
            },
            left: {
                flexGrow: 1,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "66%",
            },
            right: {
                flexGrow: 0,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            },
            messageBody: {
                paddingTop: theme.spacing(2),
                height: "100%",
                width: "100%",
                flex: 1,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontSize: theme.typography.fontSize,
            },
            wrapper: {
                margin: theme.spacing(1, 0),
            },
            unread: {
                fontWeight: 600,
            },
            input: {
                margin: 0,
            },
            attachments: {
                display: "inline",
                marginRight: theme.spacing(3),
            },
            attachmentsWrapper: {
                marginBottom: theme.spacing(2),
            },
        }),
    { name: "MessageCenter" }
);
